/**
 * Created by wwei on 2017-12-20.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import i18n from '../../i18n.js';

class LanguageSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            language: localStorage.getItem("i18nextLng")
        };
    }

    changeLanguage = (lng) => {
        this.setState({language:lng});
        i18n.changeLanguage(lng);
    }

    render() {
        const { t } = this.props;
        return (
            <div className="language-select">
                <span className="language-label">{t("FOOTER.LANGUAGE")}: &nbsp;</span>
                <select value={this.state.language} onChange={(e) => this.changeLanguage(e.target.value)}>
                    <option value="en-us">American English</option>
                    <option value="en-gb">British English</option>
                    <option value="zh-cn">简体中文</option>
                    <option value="zh-tw">繁體中文</option>
                    <option value="fr">Français</option>
                    <option value="de">Deutsch</option>
                    <option value="ja">日本語</option>
                    <option value="ko">한국어</option>
                    <option value="es">Español</option>
                    <option value="ru">Русский</option>
                    <option value="pt">Português</option>
                    <option value="ar">العربية</option>
                    <option value="hu">Magyar</option>
                    <option value="it">Italiano</option>
                    <option value="pl">Polski</option>
                    <option value="no">Norsk</option>
                </select>
            </div>
        );
    }
}

export default translate()(LanguageSelect);


// WEBPACK FOOTER //
// ./src/common/struct/LanguageSelect.js